import OriginTracer from "@atlassiansox/origin-tracing";

import { emailIsValid } from "@/components/signup/utils";
import { isProduction } from "@/utils/urls";

const getSite = () => {
    const searchParams = new URLSearchParams(globalThis.location.search);
    return searchParams.get("ondemandurl") ?? "";
};

const getOrigin = () => {
    return isProduction() ? ".atlassian.net" : ".jira-dev.com";
};

export const generateContinueUrl = (projectId?: string) => {
    const site = getSite();
    const origin = getOrigin();
    const queryParams = `${projectId ? `?projectId=${projectId}` : ""}`;

    return `https://${site}${origin}/welcome/software${queryParams}`;
};

export const generateShareLink = () => {
    const site = getSite();
    const origin = getOrigin();
    const continueUrl = encodeURIComponent(generateContinueUrl());
    const shareLink = `https://${site}${origin}?continue=${continueUrl}`;

    const withTracing = new OriginTracer({
        product: "jira"
    }).addToUrl(shareLink);

    return {
        link: withTracing
    };
};

export const POPOVER_DURATION = 2000;

// Email list analytics helper functions
export const extractEmailDomain = (email: string): string => {
    const domain = email.split("@")[1];
    return domain ? domain.toLowerCase() : "";
};

export const isCrossDomain = (emails: string[]): boolean => {
    if (emails.length <= 1) return false;

    const uniqueDomains = getUniqueEmailDomains(emails);
    return uniqueDomains.length > 1;
};

export const getUniqueEmailDomains = (emails: string[]): string[] => {
    const domains = emails
        .map(extractEmailDomain)
        .filter((domain) => domain !== "");
    return [...new Set(domains)];
};

export const getEmailListAnalytics = (emails: string[]) => {
    const validEmails = emails.filter((email) => emailIsValid(email));

    return {
        emailCount: validEmails.length,
        isCrossDomain: isCrossDomain(validEmails),
        domains: getUniqueEmailDomains(validEmails)
    };
};
